import ProposalsAdminPartial from "../../../partials/admin/proposal/proposals.admin.partials";

export default function ProposalsAdminScreen() {
  return <ProposalsAdminPartial />;
}
